// The purpose of this file is store form field constraints (rules, messages) for a HTML form.
// Note that this data is kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Create data and store it. Note that validation messages should be overriden by the server
// in the cshtml view files, to cater for different languages. The message values here are just fallbacks.
// Things should take the format of: fieldName[validatorType] = { message: "My custom message" } as per https://validatejs.org/

dataStore.set('validation.contactForm', {
    subjectInput: [
        {
            type: 'present',
            errorCode: 10050
        }
    ],
    firstNameInput: [
        {
            type: 'present',
            errorCode: 10051
        }
    ],
    lastNameInput: [
        {
            type: 'present',
            errorCode: 10052
        }
    ],
    emailAddressInput: [
        {
            type: 'present',
            errorCode: 10053
        },
        {
            type: 'email'
        }
    ],
    queryInput: [
        {
            type: 'present',
            errorCode: 10054
        }
    ]
});